var relatedSwatch = {

    elements: {},

    init: function() {
        if(!this.getElements()) {
            return;
        }
        var selectedVariant = this.getSelectedVariant();
        this.renderSwatchButton(selectedVariant);
        this.setSwatch(selectedVariant);
        this.setEvents();
    },

    getElements: function() {
        this.elements.descAdditionalInfo = jQuery('.description-container-info');
        this.elements.formSwatchButton = jQuery('#order-swatch-button');
        this.elements.formSwatchInput = jQuery('#related-swatch__input');

        return true;
    },

    renderSwatchButton: function(variant) {
       
        var _self = this;

        jQuery('.button--addRelatedSwatch').remove();

        if(!variant.related_swatch) {
            return;
        }

        this.elements.button = jQuery('<button type="button" class="button button--addRelatedSwatch button--primary__filled">Order Swatch</button>');
        this.elements.button.insertBefore(this.elements.descAdditionalInfo);
        this.elements.button.on(
            "click",
            function(){
                _self.elements.formSwatchButton.get(0).dispatchEvent(new Event("click"));
            }
        );
    },

    getSelectedVariant: function() {
        var productId = Object.keys(BoosterTheme.swatches.current)[0];
        var variants = BoosterTheme.swatches.getVariants(productId);
        var selectedVariant = variants[BoosterTheme.swatches.findVariant(productId)];

        return selectedVariant;
    },

    setSwatch: function(variant) {
        if(!variant.related_swatch) {
            return;
        }

        this.elements.formSwatchInput.val(variant.related_swatch.id);
    },

    setEvents: function() {
        var _self = this;

        BoosterTheme.swatches.events.on(
            'booster:variant:select',
            function() {
                var selectedVariant = _self.getSelectedVariant();
                _self.renderSwatchButton(selectedVariant);
                _self.setSwatch(selectedVariant);
            }
        );
    }

};

function initRelatedSwatch() {
    if(typeof BoosterTheme == 'undefined') {
        setTimeout(initRelatedSwatch, 500);
        return;
    }

    relatedSwatch.init();
}

jQuery(document).ready(
    function() {
        initRelatedSwatch();
    }
);
